import {Component, EventEmitter, Input, Output} from '@angular/core';
import { LMBuilderContext, LMBuilderModel } from "@components/builder/services/lm-builder-model.service";

@Component({
  selector: 'lm-builder-properties',
  standalone: false,
  templateUrl: './lm-builder-properties.component.html',
  styleUrl: './lm-builder-properties.component.scss',
})
export class LMBuilderPropertiesComponent{

  @Input() spec!: LMListPSpec;
  @Input() facade!: LMBusinessClassFacade;
  @Input() canAdd = true;
  @Input() addTooltip = '';
  @Input() dragTooltip = '';
  @Input() dropTargets: Array<string> = [];

  @Output() advancedSearch: EventEmitter<string> = new EventEmitter<string>();
  @Output() addField: EventEmitter<LMBuilderField> = new EventEmitter<LMBuilderField>();

  businessClass: string | undefined;
  moduleTag: string | undefined;
  listImplementation: LMBuilderListImplementation = 'live';

  constructor(
      private lmBuilderModel: LMBuilderModel
  ) {
    this.lmBuilderModel.builderContext$.next('DISPLAY_FIELDS');
    this.businessClass = this.lmBuilderModel.listResource.busClassName;
    this.moduleTag = this.lmBuilderModel.moduleTag;
    this.listImplementation = this.lmBuilderModel.listImplementation;
  }

  tabClicked(builderContext: LMBuilderContext) {
    this.lmBuilderModel.builderContext$.next(builderContext);
  }

  handleAdvancedSearch(): void {
    this.advancedSearch.emit();
  }

  handleAddField(builderField: LMBuilderField) {
    this.addField.emit(builderField);
  }
}
